import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const FrontEndAuthRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props, matchProps) => (
        localStorage.getItem('music-director') 
        ? <Component {...props} {...matchProps} /> 
        : <Redirect to={{ pathname: '/Adjudicator_Comments', state: { from: props.location } }} />
    )} />
)



// WEBPACK FOOTER //
// ./src/helper/PrivateRouteFrontEnd.jsx